import React from 'react';
import cx from 'classnames';

import styles from './FileTypeThumbnail.module.scss';

type FileTypeThumbnailProps = {
  children: React.ReactNode;
  icon: React.ReactNode;
  className?: string;
  iconOnly?: boolean;
};

const FileTypeThumbnail: React.FC<FileTypeThumbnailProps> = ({ children, icon, className, iconOnly = false }) => (
  <div className={cx(iconOnly ? styles.iconOnlyContainer : styles.container, className)}>
    {!iconOnly && <div className={styles.thumbnail}>{children}</div>}
    <div className={iconOnly ? styles.iconOnly : styles.icon}>{icon}</div>
  </div>
);

export default FileTypeThumbnail;
